/* ============================================================
   カテゴリの見出しを「押しても何も起きない」ようにする
   Yesterday / Horizon   2026-08-09（2026-08-20 4.1.4対応: PCセレクタ追加）
   ------------------------------------------------------------
   ■ 目的

   「商品ジャンル」は見出しとして置いているが、Shopifyのメニューは
   URL なしの項目を作れないので、実態はリンクになる。
   行き先は /collections/all で、すぐ上の「全ての商品」と同じ。
   押すと同じページへ飛ぶので違和感がある、というのが発端。

   遷移だけを止める。パネルは開いたままにする。

   ■ なぜ CSS の pointer-events: none ではだめなのか（PC）

   Horizon はパネルを開いたまま保つために、
   リンクの下に「セーフティボックス」を出している。

     .menu-list__link::after { top: var(--header-padding); height: var(--box-height); }
     .menu-list__link[data-safety-box='true']::after { display: block; }

   assets/header-menu.js がポインタ移動中だけこれを表示し、
   リンクからパネルへカーソルを移す途中の隙間を埋めている。
   リンクに pointer-events: none をかけるとこの疑似要素も反応しなくなり、
   隙間を横切った瞬間に <li> の pointerleave が発火して
   パネルが閉じる。2026-08-08 に直したhoverの不安定さが再発する。

   なので PC ではクリックだけを JS で止める。
   モバイルのドロワーはhoverの仕組みがないので
   assets/category-menu-drawer.css 側で pointer-events: none をかけている
   （タップ時の反応を出さないため）。
   ただし pointer-events はキーボード操作を止められないので、
   Enter での遷移はこのファイルが両方とも担当する。

   ■ 注意

   ・子メニューを持つトップレベル項目はすべて対象になる。
     現在は「商品ジャンル」だけ。将来別の親項目を足して
     そちらは押せるようにしたい場合は、下の SELECTOR を絞ること。
   ・キーボードの Enter も同じく何も起きなくなる。
     見出しにフォーカスが当たるとパネルが開く（Horizonの標準挙動）ので、
     Tab でカテゴリ8項目には到達できる。
   ・やめるときは snippets/stylesheets.liquid の読み込み1行を消す。
   ============================================================ */

(() => {
  /** PC：メガメニューを持つトップレベル項目
      3.5.1: <a class="menu-list__link" aria-haspopup="true">
      4.1.4: aria-haspopup が <a> から外れ、<span class="menu-list__trigger"> が
             <a> を包む構造に変わった（開閉は別の disclosure ボタンが担当）。
             両方のマークアップに効くよう2つのセレクタを併記している。 */
  const MEGA_MENU_HEADING = [
    '#header-component .menu-list__link[aria-haspopup="true"]',
    '#header-component .menu-list__trigger > .menu-list__link',
  ].join(', ');

  /** モバイル：ドロワーの見出し（直後に子リストが続くものだけ） */
  const DRAWER_HEADING = '#header-component a.menu-drawer__menu-item--mainlist';

  /**
   * クリックされたものが見出しなら true。
   * @param {EventTarget | null} target
   * @returns {boolean}
   */
  function isHeading(target) {
    if (!(target instanceof Element)) return false;

    if (target.closest(MEGA_MENU_HEADING)) return true;

    const drawer = target.closest(DRAWER_HEADING);
    if (drawer && drawer.nextElementSibling instanceof Element) {
      return drawer.nextElementSibling.classList.contains('menu-drawer__menu--childlist');
    }

    return false;
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!isHeading(event.target)) return;
      event.preventDefault();
    },
    // キャプチャ。他のリスナーより先に走らせる
    true
  );
})();
